/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MailNodeSubjectType {
    Unrestricted = '0',
    Resource = 1,
    Location = 2,
    None = 3,
}
